module.exports = __webpack_public_path__ + "static/media/icon_cap_orange.c2e30261.svg";